'use strict';
import get from 'lodash/get';
import isFunction from 'lodash/isFunction';
import {createEventHandler} from 'recompose';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/combineLatest';
import 'rxjs/add/operator/last';
import 'rxjs/add/operator/takeUntil';
import {Observable} from 'rxjs/Observable';
import {buildInjector} from '../../../_libs/angular-utils';
import {listToArray} from '../../../_libs/redux-observable-list';
import {isCordovaBuild} from '../../../config/constants';
import {
  supportsCamera,
  supportsVideo,
  supportsDownload,
  supportsPickFile, isWebView,
} from '../../../core-utilities-implementation/device-services/DeviceServicesCordova';
import {getId} from '../../../core-utilities/domain/ReduxUtils';
import {getDataTransferFiles} from '../../../core-utilities/upload-service/getDataTransferFiles';
import {fileIsImage} from '../../../files/domain/FileDomain';
import {buildPropsByCollection} from '../../redux/utils';
import {buildGoBack, getFulfillmentFile} from '../../utils';


// Use legacy service to locally handle per-item requests, since they are allowed to occur in parallel
const dependencies = {};
export const injector = buildInjector(dependencies, [
  'PersistentUploaderService',
]);

/**
 * @param {Object} config
 * @param {String} config.collection
 * @param {ReduxList} config.reduxList
 * @param {ReduxRequestModal} config.updateReduxRequestModal
 */
export const RequirementViewFilesContainer = (config) => (state$, dispatch) => (props$) => {
  const PersistentUploaderService = dependencies.PersistentUploaderService;
  const {
    collection,
    taskListState,
    taskDetailsState,
    reduxList,
    updateReduxRequestModal,
  } = config;

  const {
    stateParams$,
    requirement$,
    breadcrumbPath$,
  } = buildPropsByCollection(collection, state$, props$);

  /** @type {ReduxObservableListActions} */
  const actions = reduxList.actions;
  /** @type {ReduxObservableListOptions} */
  const reduxListOptions = reduxList.options;

  const onClickEdit = createEditEvent(updateReduxRequestModal, requirement$, dispatch, props$);
  const onGoBack = buildGoBack({
    props$,
    requirement$,
    taskListState,
    taskDetailsState,
    dispatch,
  });
  const {
    handler: onOpenPreviewer,
    stream: openPreviewer$,
  } = createEventHandler();

  const {
    handler: onRetryUploads,
    stream: retryUploads$,
  } = createEventHandler();
  const onClickItem = (e, model) => {
    e.stopPropagation();
    onOpenPreviewer(getFulfillmentFile(model));
  };
  const onClickUpload = (e, model) => {
    e.stopPropagation();
    // TODO: fix and test opening pending uploads.
    // onOpenPreviewer(model);
  };
  const {
    handler: onDropFile,
    stream: dropFile$,
  } = createEventHandler();

  const reqId$ = requirement$
    .map(getId)
    .distinctUntilChanged();

  const uploading$ = reqId$
    .switchMap(id => !id
      ? Observable.of([])
      : PersistentUploaderService.getByKey$(id)
    );

  openPreviewer$
    .withLatestFrom(props$, state$, uploading$)
    .takeUntil(props$.last())
    .subscribe(([model, props, rootState, uploading]) => {
      const files = getImagesFromList(listToArray(reduxListOptions, reduxListOptions.getState(rootState)))
        .concat(getImagesFromUploading(uploading));

      if (!props.openingFileId && isFunction(props.onOpenPreviewer)) {
        props.onOpenPreviewer(model, files);
      }
    });

  dropFile$
    .withLatestFrom(props$)
    .takeUntil(props$.last())
    .subscribe(([e, props]) => {
      if (isFunction(props.onDropFile)) {
        const files = getDataTransferFiles(e, true);
        props.onDropFile(files);
      }
    });

  retryUploads$
    .debounceTime(300)
    .subscribe(() => {
      PersistentUploaderService.tryUploads();
    });

  return props$
    .combineLatest(
      stateParams$,
      requirement$,
      breadcrumbPath$,
      uploading$,
      (props, stateParams, requirement, breadcrumbPath, uploading) => ({
        ...props,
        parentId: get(stateParams, 'requirementId'),
        collection,
        // init: !!requirement,
        requirement,
        breadcrumbPath,
        uploading: uploading.files,
        uploadingStatus: uploading.meta,

        showCameraButton: supportsCamera(),
        showVideoButton: supportsVideo(),
        showUploadButton: supportsPickFile(),
        showIOSUpButton: supportsPickFile() && isWebView(),
        showDownloadButton: supportsDownload(),
        canRetryUploads: isCordovaBuild(),

        onGoBack,
        onClickEdit,
        onClickItem,
        onClickUpload,
        onDropFile,
        onRetryUploads,
      }));
};

function getImagesFromList(list) {
  const results = [];
  for (let i = 0, len = list.length; i < len; i++) {
    const file = get(list[i], 'currentFileAsset.file');
    if (file && fileIsImage(file)) {
      results.push(file);
    }
  }
  return results;
}

function getImagesFromUploading(uploading) {
  const results = [];
  for (let i = 0, len = uploading.length; i < len; i++) {
    if (fileIsImage(uploading[i])) {
      results.push(uploading[i]);
    }
  }
  return results;
}

/**
 * @param {ReduxRequestModal} updateReduxRequestModal
 * @param {Observable} requirement$
 * @param {Function} dispatch
 * @param {Observable} props$
 */
function createEditEvent(updateReduxRequestModal, requirement$, dispatch, props$) {
  const {
    handler: onClickEdit,
    stream: edit$,
  } = createEventHandler();

  edit$
    .withLatestFrom(requirement$)
    .takeUntil(props$.last())
    .subscribe(([e, requirement]) => {
      e.stopPropagation();
      dispatch(updateReduxRequestModal.actions.showModal({model: requirement}));
    });

  return onClickEdit;
}



// WEBPACK FOOTER //
// ./src/js/requirements/components/RequirementViewFiles/RequirementViewFilesContainer.js